/** @jsx jsx */
import { forwardRef } from 'react';
import { jsx } from '@emotion/core';
import { useShouldNestedElementRender } from '../NestableNavigationContent/context';
import { containerCSS, innerContainerCSS, outerContainerCSS } from './styles';
import { useScrollbarWidth } from './use-scrollbar-width';
var NavigationContent = /*#__PURE__*/forwardRef(function (props, ref) {
  var showTopScrollIndicator = props.showTopScrollIndicator,
      children = props.children;

  var _useShouldNestedEleme = useShouldNestedElementRender(),
      shouldRender = _useShouldNestedEleme.shouldRender;

  var scrollbar = useScrollbarWidth();

  if (!shouldRender) {
    return children;
  }

  return jsx("div", {
    ref: ref,
    css: outerContainerCSS({
      showTopScrollIndicator: showTopScrollIndicator,
      scrollbarWidth: scrollbar.width
    })
  }, jsx("div", {
    ref: scrollbar.ref,
    css: innerContainerCSS({
      showTopScrollIndicator: showTopScrollIndicator
    })
  }, jsx("div", {
    css: containerCSS({
      showTopScrollIndicator: showTopScrollIndicator
    })
  }, children)));
});
export default NavigationContent;